import { render, staticRenderFns } from "./CheckoutKioskInhouseTip.vue?vue&type=template&id=06b40254&scoped=true"
import script from "./CheckoutKioskInhouseTip.vue?vue&type=script&lang=js"
export * from "./CheckoutKioskInhouseTip.vue?vue&type=script&lang=js"
import style0 from "./CheckoutKioskInhouseTip.vue?vue&type=style&index=0&id=06b40254&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b40254",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b40254')) {
      api.createRecord('06b40254', component.options)
    } else {
      api.reload('06b40254', component.options)
    }
    module.hot.accept("./CheckoutKioskInhouseTip.vue?vue&type=template&id=06b40254&scoped=true", function () {
      api.rerender('06b40254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/kiosk/CheckoutKioskInhouseTip.vue"
export default component.exports